The page of hirers and their corresponding cursors.
